import { PropertiesPanel } from '../../../../../../widgets/propertiesPanel';
import React, { FC, useMemo } from 'react';
import { T } from 'src/shared/helpers';
import { CameraConfigHelpers, CameraNode, CameraProperty, useCameraPropertiesCreator } from '../cameraEditorConfig';
import InspectorShell from '../inspectorShell';

// L'involucro sta in `InspectorShell`, uno per tutti i generi: qui resta ciò che è solo di
// una camera.

export interface CameraOverlayProps {
    camera: {
        id: string;
        name: string;
        position: [number, number, number];
        target: [number, number, number];
        fov: number;
        isActive: boolean;
        enableZoomLimit: boolean;
        enableHorizontalLimit: boolean;
        enableVerticalLimit: boolean;
        // Proprietà zoom
        useMinZoomPerc: boolean;
        useMaxZoomPerc: boolean;
        minZoomPerc: number;
        maxZoomPerc: number;
        // Proprietà rotazione
        lowerBetaLimits: number | undefined;
        upperBetaLimits: number | undefined;
        lowerAlphaLimit: number | undefined;
        upperAlphaLimit: number | undefined;
        height: number;
    };
    onPropertyChange: (property: CameraProperty, value?: any) => void;
}

const CameraSettingOverlayComponent: FC<CameraOverlayProps> = ({ camera, onPropertyChange }) => {
    // Hook per creare le proprietà della camera
    const createCameraProperties = useCameraPropertiesCreator();

    // Crea gli helpers per la configurazione delle proprietà
    const helpers: CameraConfigHelpers = useMemo(
        () => ({
            onPropertyChange
        }),
        [onPropertyChange]
    );

    // Genera le proprietà usando il factory pattern
    const properties = useMemo(() => {
        return createCameraProperties(camera as CameraNode, helpers);
    }, [createCameraProperties, camera, helpers]);

    // Il nome di una camera lo cambia la sua lista, con il comando Rename: qui si legge.
    // Il tipo — Perspective o Orthographic — non è nel dato salvato (registro, riga 9),
    // quindi le specifiche dicono l'unica cosa vera, il campo visivo.
    return (
        <InspectorShell kind='camera' name={camera.name} specs={camera.fov ? `${T._('FOV', 'Admin')} ${Math.round(camera.fov)}°` : undefined}>
            <PropertiesPanel properties={properties} />
        </InspectorShell>
    );
};

export default CameraSettingOverlayComponent;
